export enum BankType {
  US_MANUAL = 'US_MANUAL',
  INTERNATIONAL = 'INTERNATIONAL',
}

export enum AccountType {
  CHECKING = 'CHECKING',
  SAVINGS = 'SAVINGS',
  MONEY_MARKET = 'MONEY_MARKET',
}

export enum BankStatus {
  ACTIVE = 'ACTIVE',
  WHITELIST_APPROVED = 'WHITELIST_APPROVED',
  ADMIN_APPROVED = 'ADMIN_APPROVED',
  BLOCKED = 'BLOCKED',
  REQUIRES_APPROVAL = 'REQUIRES_APPROVAL',
}

export class BankDetail {
  id: number | null = null;
  bankType = BankType.US_MANUAL;
  accountType = AccountType.CHECKING;
  name?: string;
  bankName?: string;
  bankAddress?: string;
  wireRoutingNumber?: string;
  achRoutingNumber?: string;
  swiftCode?: string;
  accountNumber?: string;
  referenceText?: string;
  editable?: boolean;
  isDefault?: boolean;
  status?: BankStatus;

  constructor(raw: any) {
    if (raw) {
      this.id = raw.id;
      this.bankType = raw.bankType;
      this.accountType = raw.accountType;
      this.name = raw.name;
      this.bankName = raw.bankName;
      this.bankAddress = raw.bankAddress;
      this.wireRoutingNumber = raw.wireRoutingNumber;
      this.achRoutingNumber = raw.achRoutingNumber;
      this.swiftCode = raw.swiftCode;
      this.accountNumber = raw.accountNumber;
      this.referenceText = raw.referenceText;
      this.editable = raw.editable;
      this.isDefault = raw.default;
      this.status = raw.status;
    }
  }

  get maskedAccountNumber(): string {
    if (this.accountNumber && this.accountNumber.length > 4) {
      return 'XXXXXXXX' + this.accountNumber.substring(this.accountNumber.length - 4);
    } else {
      return 'XXXXXXXX';
    }
  }
}
